import React from 'react';

import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { toggleBackgroundJobExtendedInfoDialog } from '../actions/ToggleBackgroundJobExtendedInfoDialog';
import { IBackgroundJobInfo } from '../types/BackgroundJobs';

export class BackgroundJobExtendedInfoDialogCell extends React.Component<IBackgroundJobInfo> {

  private readonly toggleDilog = () => {
    getAppStore().dispatch(toggleBackgroundJobExtendedInfoDialog(this.props));
  };

  render() {
    /* eslint-disable jsx-a11y/interactive-supports-focus */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/anchor-is-valid */
    return <>
      <a data-tb-test-id="data-grid-cell-text" onClick={this.toggleDilog} role="button">
        {this.props.jobId + ''}
      </a>
    </>;
  }
}
